var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"login-container"},[_c('SVGSpinner',{staticClass:"spinner"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }